import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-25c78e06"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "sondertilgung-result"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row line-phone" }, null, -1))
const _hoisted_3 = { class: "sondertilgung-result-line" }
const _hoisted_4 = { class: "sondertilgung-result-text" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = {
  key: 0,
  class: "sondertilgung-result-line"
}
const _hoisted_7 = { class: "sondertilgung-result-text" }
const _hoisted_8 = { class: "bold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_slider = _resolveComponent("slider")!
  const _component_klapper = _resolveComponent("klapper")!

  return (_ctx.sondertilgungVisible)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["calculate-sondertilgung", _ctx.isKlapperOpen ? 'opened' : ''])
      }, [
        _createVNode(_component_klapper, {
          title: _ctx.textKlapperSondertilgung,
          onKlapperTriggered: _ctx.onKlapperTriggered,
          "tracking-action": "1.1_sondertilgung_klapper"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_slider, {
              id: "sondertilgung",
              labelText: _ctx.textSliderSondertilgung,
              "slider-values": _ctx.sliderSondertilgung,
              "tooltip-text": _ctx.textToolTipSondertilgung,
              unit: "€",
              "input-annotation": 'Max. '+ _ctx.sliderSondertilgung.max,
              onValueChanged: _ctx.onSondertilgungChanged
            }, null, 8, ["labelText", "slider-values", "tooltip-text", "input-annotation", "onValueChanged"]),
            (_ctx.einsparungBetrag !== '')
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                  _hoisted_2,
                  _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.textGesparterBetragSondertilgung), 1),
                    _createElementVNode("span", {
                      class: "bold",
                      innerHTML: _ctx.einsparungBetrag
                    }, null, 8, _hoisted_5)
                  ]),
                  (_ctx.einsparungZeit !==  '')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.textGesparteLaufzeitSondertilgung), 1),
                        _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.einsparungZeit), 1)
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["title", "onKlapperTriggered"])
      ], 2))
    : _createCommentVNode("", true)
}